import { useState } from 'react';

export function useFileHubModals() {
  const [signatureModal, setSignatureModal] = useState(null);
  const [reorderModal, setReorderModal] = useState(null);
  const [petitionModal, setPetitionModal] = useState(null);
  const [petitionBusy, setPetitionBusy] = useState(false);
  const [nukeBusy, setNukeBusy] = useState(false);
  const [aiWizardOpen, setAiWizardOpen] = useState(false);
  const [aiWizardText, setAiWizardText] = useState('');
  const [aiWizardPhase, setAiWizardPhase] = useState('input');
  const [aiWizardItems, setAiWizardItems] = useState([]);

  return {
    signatureModal, setSignatureModal,
    reorderModal, setReorderModal,
    petitionModal, setPetitionModal,
    petitionBusy, setPetitionBusy,
    nukeBusy, setNukeBusy,
    aiWizardOpen, setAiWizardOpen,
    aiWizardText, setAiWizardText,
    aiWizardPhase, setAiWizardPhase,
    aiWizardItems, setAiWizardItems,
  };
}
